module.exports = __webpack_public_path__ + "static/media/icon_info_orange.a91cbc99.svg";